// platform
const platformData = [
  { id: "", name: "全部" },
  { name: "亚马逊", id: 1 },
  { name: "速卖通", id: 2 },
  { name: "wish", id: 3 },
  { name: "shopee", id: 4 },
  { name: "shopify", id: 5 },
  { name: "lazada", id: 6 },
  { name: "etsy", id: 7 },
  { name: "店匠", id: 8 },
  { name: "其他", id: 99 }
]

const platformData2 = [
  { name: "亚马逊", id: 1 },
  { name: "速卖通", id: 2 },
  { name: "wish", id: 3 },
  { name: "shopee", id: 4 },
  { name: "shopify", id: 5 },
  { name: "lazada", id: 6 },
  { name: "etsy", id: 7 },
  { name: "店匠", id: 8 },
  { name: "其他", id: 99 }
]
const statusMap = [
  { name: "发货计划", id: 1 },
  { name: "支付货款", id: 2 },
  { name: "生产与装箱", id: 3 },
  { name: "支付运费", id: 4 },
  { name: "上传箱子标签", id: 5 },
  { name: "发货", id: 6 }
]
const statusMapAll = [
  { name: "全部订单", id: "" },
  { name: "发货计划", id: 1 },
  { name: "支付货款", id: 2 },
  { name: "生产与装箱", id: 3 },
  { name: "支付运费", id: 4 },
  { name: "上传箱子标签", id: 5 },
  { name: "发货", id: 6 }
]
const errStatus = [
  { name: "派单异常", id: 8 },
  { name: "生产异常", id: 9 },
  { name: "运单生产异常", id: 10 },
  { name: "发货异常", id: 11 }
]
const orderTypeDateAll = [
  { name: "全部订单", id: "" },
  { name: "未确认", id: 1 },
  { name: "未付款", id: 2 },
  { name: "审核中", id: 3 },
  { name: "排单中", id: 4 },
  { name: "生产中", id: 5 },
  { name: "已发货", id: 6 },
  { name: "已取消", id: 7 },
  { name: "派单异常", id: 8 },
  { name: "生产异常", id: 9 },
  { name: "运单生成异常", id: 10 },
  { name: "发货异常", id: 11 }
]

// 来源聚道
const registerSource = [
  {
    name: "抖音",
    id: 4
  },
  {
    name: "知乎",
    id: 9
  },
  {
    name: "微信公众号",
    id: 3
  },
  {
    name: "微信视频号",
    id: 20
  },
  {
    name: "小红书",
    id: 11
  },
  {
    name: "1688",
    id: 19
  },
  {
    name: "百度搜索",
    id: 2
  },
  {
    name: "搜狐号",
    id: 14
  },
  {
    name: "百家号",
    id: 15
  },
  {
    name: "朋友介绍",
    id: 1
  },
  {
    name: "宣传海报",
    id: 6
  },
  {
    name: "电梯广告",
    id: 5
  },

  {
    name: "Shoplazz",
    id: 7
  },
  {
    name: "Shopify",
    id: 8
  },
  {
    name: "今日头条",
    id: 12
  },
  {
    name: "微博",
    id: 10
  },
  {
    name: "快手",
    id: 16
  },
  {
    name: "手机端",
    id: 17
  },
  {
    name: "其他",
    id: 13
  }
]

export { platformData, platformData2, statusMap, statusMapAll, errStatus, orderTypeDateAll, registerSource }
